import localStorageUtils from "@iso/lib/helpers/localStorageUtils";
import { takeEvery, put } from "redux-saga/effects";
import actions from "./actions";

function* checkAuthorization() {
  yield takeEvery(actions.INFI_CHECK_AUTHORIZATION, function* () {
    const token = localStorageUtils.getToken();
    if (token) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token,
        profile: "Profile"
      });
    }
  });
}

export default { checkAuthorization };
